"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationStateChanged = exports.isFormGroup = exports.isForm = exports.isFormInput = void 0;
const _ = __importStar(require("lodash"));
const debug_1 = __importDefault(require("debug"));
const log = (0, debug_1.default)('itp:ui:components:form:helpers');
const FORM_INPUT_DESIGNER_TYPES = [
    'ItpFormInput',
    'ItpFormSelect',
    'ItpFormTextarea',
    'ItpFormCheckbox',
    'FormInputDesigner',
    'FormSelectDesigner'
];
function isFormInput(spec) {
    return FORM_INPUT_DESIGNER_TYPES.indexOf(spec.tagName) > -1;
}
exports.isFormInput = isFormInput;
function isForm(spec) {
    return spec.tagName === 'ItpForm';
}
exports.isForm = isForm;
function isFormGroup(spec) {
    return spec.tagName === 'ItpFormGroup';
}
exports.isFormGroup = isFormGroup;
function validationStateChanged(a, b) {
    return (a.state !== b.state ||
        a.errors.length !== b.errors.length ||
        !_.isEqual(a.errors, b.errors));
}
exports.validationStateChanged = validationStateChanged;
//# sourceMappingURL=helpers.js.map